import { render } from "./AdminDashboard.vue?vue&type=template&id=67c67d34&scoped=true"
import script from "./AdminDashboard.vue?vue&type=script&lang=js"
export * from "./AdminDashboard.vue?vue&type=script&lang=js"

import "./AdminDashboard.vue?vue&type=style&index=0&id=67c67d34&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67c67d34"]])

export default __exports__